import { RefNumber, Collection } from "@tblabs/truffle";
import { Discount } from "./Discount";


export class BasketConfig
{
    public GeneralPriceFactor = new RefNumber(1);
    public DeliveryCostForPriceAbove300 = new RefNumber(25);
    public DeliveryCostForPriceBelow300 = new RefNumber(1);
    public Discounts = new Collection<Discount>([]);
}
